import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getBibliotecasPredSvg,
  deleteBibliotecaPredSvg,
  getBibliotecaPredSvgById,
  insertBibliotecaPredSvg,
  updateBibliotecaPredSvg,
  getBibliotecasPredSvgFiltered,
  getBibPreByBibPlantillaId,
  getEnums,
  getBibPredByProductoId,
  updateBibliotecasPredSvgProducto,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'
import history from '../../history'

export function* GET_BIBPREDSVG() {
  try {
    const bibliotecasPredSvgData = yield call(getBibliotecasPredSvg)
    if (bibliotecasPredSvgData.ok) {
      yield put({
        type: actions.BIBPREDSVG_LOAD_SUCCEEDED,
        payload: bibliotecasPredSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
      put({
        type: actions.BIBPREDSVG_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
    yield all([
      put({
        type: actions.BIBPREDSVG_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPREDSVG_BY_BIBPLANTILLA_ID(action) {
  try {
    const bibliotecasPredSvgData = yield call(getBibPreByBibPlantillaId, action.payload)
    if (bibliotecasPredSvgData.ok) {
      yield put({
        type: actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_SUCCEEDED,
        payload: bibliotecasPredSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
      put({
        type: actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
    yield all([
      put({
        type: actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPREDSVG_BY_PRODUCTO_ID(action) {
  try {
    const bibliotecasPredSvgData = yield call(getBibPredByProductoId, action.payload)
    if (bibliotecasPredSvgData.ok) {
      yield put({
        type: actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED,
        payload: bibliotecasPredSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
      put({
        type: actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
    yield all([
      put({
        type: actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBPREDSVG(action) {
  try {
    const descuentoData = yield call(deleteBibliotecaPredSvg, action.payload)
    if (descuentoData.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Prediseño SVG eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBPREDSVG_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el Biblioteca de Prediseño SVG')
      put({
        type: actions.DELETE_BIBPREDSVG_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el Biblioteca de Prediseño SVG')
    yield all([
      put({
        type: actions.DELETE_BIBPREDSVG_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPREDSVG_BY_ID(action) {
  try {
    const descuentoData = yield call(getBibliotecaPredSvgById, action.payload)
    if (descuentoData.ok) {
      yield put({
        type: actions.BIBPREDSVG_BYID_LOAD_SUCCEEDED,
        payload: descuentoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
      put({
        type: actions.BIBPREDSVG_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Prediseño SVG')
    yield all([
      put({
        type: actions.BIBPREDSVG_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBPREDSVG(action) {
  try {
    const bibPredSvg = yield call(insertBibliotecaPredSvg, action.payload)
    if (bibPredSvg.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Prediseño SVG creada correctamente')
      history.push(`/bibpredsvg/edit/${bibPredSvg.data.id}`)
      // yield put({
      //   type: actions.BIBPREDSVG_INSERT_SUCCEEDED,
      //   payload: bibPredSvg.data,
      // })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca de Prediseño SVG')
      yield put({
        type: actions.BIBPREDSVG_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca de Prediseño SVG')
    yield all([
      put({
        type: actions.BIBPREDSVG_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBPREDSVG(action) {
  try {
    const bibPredSvg = yield call(updateBibliotecaPredSvg, action.payload)
    if (bibPredSvg.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Prediseño SVG modificada correctamente')
      yield put({
        type: actions.BIBPREDSVG_UPDATE_SUCCEEDED,
        payload: bibPredSvg.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Prediseño SVG')
      yield put({
        type: actions.BIBPREDSVG_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Prediseño SVG')
    yield all([
      put({
        type: actions.BIBPREDSVG_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBSPREDSVG_PRODUCTO(action) {
  try {
    const bibliotecasPredSvgByProducto = yield call(
      updateBibliotecasPredSvgProducto,
      action.payload,
    )
    if (bibliotecasPredSvgByProducto.ok) {
      putMessage(
        messageType.SUCCESS,
        'Bibliotecas de Prediseño SVG modificada correctamente para este producto',
      )
      yield put({
        type: actions.BIBSPREDSVG_PRODUCTO_UPDATE_SUCCEEDED,
        payload: bibliotecasPredSvgByProducto.data,
      })
    } else {
      putMessage(
        messageType.ERROR,
        'Error al modificar Bibliotecas de Prediseño SVG para este producto',
      )
      yield put({
        type: actions.BIBSPREDSVG_PRODUCTO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(
      messageType.ERROR,
      'Error al modificar Biblioteca de Prediseño SVG para este producto',
    )
    yield all([
      put({
        type: actions.BIBSPREDSVG_PRODUCTO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPREDSVG_FILTERED(action) {
  try {
    const bibliotecasPredSvgData = yield call(getBibliotecasPredSvgFiltered, action.payload)
    if (bibliotecasPredSvgData.ok) {
      yield put({
        type: actions.BIBPREDSVG_FILTERED_LOAD_SUCCEEDED,
        payload: bibliotecasPredSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bibliotecas de Prediseño SVG')
      put({
        type: actions.BIBPREDSVG_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBPREDSVG_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ENUMS() {
  try {
    const enumsData = yield call(getEnums)
    if (enumsData.ok) {
      yield put({
        type: actions.ENUMS_LOAD_SUCCEEDED,
        payload: enumsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Enums')
      put({
        type: actions.ENUMS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ENUMS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BIBPREDSVG_LOAD_REQUESTED, GET_BIBPREDSVG),
    takeEvery(actions.DELETE_BIBPREDSVG_REQUESTED, DELETE_BIBPREDSVG),
    takeEvery(actions.BIBPREDSVG_BYID_LOAD_REQUESTED, GET_BIBPREDSVG_BY_ID),
    takeEvery(actions.BIBPREDSVG_UPDATE_REQUESTED, UPDATE_BIBPREDSVG),
    takeEvery(actions.BIBPREDSVG_INSERT_REQUESTED, INSERT_BIBPREDSVG),
    takeEvery(actions.BIBPREDSVG_FILTERED_LOAD_REQUESTED, GET_BIBPREDSVG_FILTERED),
    takeEvery(actions.ENUMS_LOAD_REQUESTED, GET_ENUMS),
    takeEvery(
      actions.BIBPREDSVG_BY_BIBPLANTILLA_ID_LOAD_REQUESTED,
      GET_BIBPREDSVG_BY_BIBPLANTILLA_ID,
    ),
    takeEvery(actions.BIBPREDSVG_BY_PRODUCTO_ID_LOAD_REQUESTED, GET_BIBPREDSVG_BY_PRODUCTO_ID),
    takeEvery(actions.BIBSPREDSVG_PRODUCTO_UPDATE_REQUESTED, UPDATE_BIBSPREDSVG_PRODUCTO),
  ])
}
